import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {StepButtonProps} from '../../slider-control.types';
import styles from '../../slider-control.module.scss';

export function StepButton({direction, disabled, onClick}: StepButtonProps): ReactElement {
  const iconClass = direction === 'plus' ? 'icon-plus' : 'icon-minus';
  const label = direction === 'plus' ? window.i18next.t('pmwjs_increment') : window.i18next.t('pmwjs_decrement');
  return (
    <div className={`${styles.stepButton} ${disabled ? styles.stepButtonDisabled : ''}`}>
      <Icon ariaLabel={label} icon={iconClass} isDisabled={disabled} isUsedAsButton onClick={onClick} size={IconSize.SIZE_ICON_16} />
    </div>
  );
}
